import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { FlightCadSummary } from 'src/store/flight-log/flight-log.model';
import { assertNotNullOrWhitespace } from 'src/util/values';
import { FlightLogApiConfiguration, FLIGHT_LOG_API_CONFIG } from '../flight-log-api-configuration';

@Injectable({ providedIn: 'root' })
export class FlightSummaryHttpClient {
  constructor(
    @Inject(FLIGHT_LOG_API_CONFIG) private config: FlightLogApiConfiguration,
    private http: HttpClient,
  ) {}

  public getById(flightId: string): Observable<FlightCadSummary | undefined> {
    assertNotNullOrWhitespace(flightId, 'flightId');
    return this.http.get<FlightCadSummary>(this._url(`flights/${flightId}`));
  }

  public getByEmployeeId(employeeId: string): Observable<FlightCadSummary[]> {
    assertNotNullOrWhitespace(employeeId, 'employeeId');
    return this.http.get<FlightCadSummary[]>(this._url(`flights`), {
      params: {
        pilotEmployeeId: employeeId,
      },
    });
  }

  public getUnloggedByEmployeeId(employeeId: string): Observable<FlightCadSummary[]> {
    assertNotNullOrWhitespace(employeeId, 'employeeId');
    return this.http.get<FlightCadSummary[]>(this._url(`flights/unlogged`), {
      params: {
        pilotEmployeeId: employeeId,
      },
    });
  }

  private _url(path: string) {
    return this.config.baseUri + '/api/' + path;
  }
}
